import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentMapDetails from "./routes/DepartmentMapDetails";

export default store => ({
  path: "department-map",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "department-map" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [DepartmentMapDetails(store)],
});
